/* eslint-disable guard-for-in */
/* eslint-disable no-case-declarations */
/* eslint-disable no-restricted-syntax */
import { each } from "lodash";
import { ActionTypes } from "../actions/types";
import { NAVIGATION_NEXT_PAGE, RESET_MENTIONS, UPDATE_QUESTION_FIELD_STATUS } from "../actions";
import { QuestionnaireModel } from "../../models/QuestionnaireModel";
import { QuestionType } from "../../models/enums/QuestionType";
import { getQuestionWithVariable } from "../../models/utilities/questionnaireUtilities";

import { MentionModel } from "../../models/MentionModel";
import { getSettingString } from "../../models/utilities/settingUtilities";
import { AxisModel } from "../../models/AxisModel";
import { QuestionModel } from "../../models/QuestionModel";

const INITIAL_STATE = {};

export const questionFieldStatusReducer = (
    state = INITIAL_STATE,
    action: ActionTypes,
    questionnaire: QuestionnaireModel,
    previousMentionsByVariableName: { [variableName: string]: MentionModel[] },
) => {
    const reducerStates = { ...state };
    const changeReducerStateForVariableCells: [string, boolean][] = [];
    let disableColumnsList = [];

    switch (action.type) {
        case NAVIGATION_NEXT_PAGE:
            console.log(previousMentionsByVariableName);
            each(previousMentionsByVariableName, (mentions, variableName) => {
                if (Object.keys(previousMentionsByVariableName).includes(variableName)) {
                    const question = getQuestionWithVariable(questionnaire, variableName);
                    updateStatusForHybridQuestionMapppedVariableCells(
                        question,
                        reducerStates,
                        variableName,
                        disableColumnsList,
                        changeReducerStateForVariableCells,
                        previousMentionsByVariableName,
                    );
                }
                disableColumnsList = []; // For each row reset column might be different
            });

            changeReducerStateForVariableCells.forEach(([identifierId, newStatus]) => {
                reducerStates[identifierId] = {
                    ...reducerStates[identifierId],
                    isDisabled: newStatus,
                };
            });

            return reducerStates;
        case RESET_MENTIONS:
            const resetForMentions = findChangedMentionsForVariableNames(
                action.mentions,
                previousMentionsByVariableName,
            );

            each(resetForMentions, (mentions, variableName) => {
                if (Object.keys(resetForMentions).includes(variableName)) {
                    const question = getQuestionWithVariable(questionnaire, variableName);
                    updateStatusForHybridQuestionMapppedVariableCells(
                        question,
                        reducerStates,
                        variableName,
                        disableColumnsList,
                        changeReducerStateForVariableCells,
                        action.mentions,
                    );
                }
                disableColumnsList = []; // For each row reset column might be different
            });

            changeReducerStateForVariableCells.forEach(([identifierId, newStatus]) => {
                reducerStates[identifierId] = {
                    ...reducerStates[identifierId],
                    isDisabled: newStatus,
                };
            });

            return reducerStates;
        case UPDATE_QUESTION_FIELD_STATUS:
            const { fieldIdentifiers } = action;

            for (const key in fieldIdentifiers) {
                const fieldKey = fieldIdentifiers[key];
                if (!reducerStates[fieldKey]) {
                    // Initialize the state for new instanceId
                    reducerStates[fieldKey] = {
                        isDisabled: action.isDisabled,
                    };
                } else {
                    // Update the state for existing instanceId
                    reducerStates[fieldKey] = {
                        ...reducerStates[fieldKey],
                        isDisabled: action.isDisabled,
                    };
                }
            }

            return reducerStates;
        default:
            return reducerStates;
    }
};

function findChangedMentionsForVariableNames(
    oldMentionsByVariableName: { [variableName: string]: MentionModel[] },
    newMentionsByVariableName: { [variableName: string]: MentionModel[] },
): { [variableName: string]: MentionModel[] } {
    const result: { [variableName: string]: MentionModel[] } = {};

    // Get old mentions which are removed
    Object.keys(oldMentionsByVariableName).forEach((variableName) => {
        const oldVariableMentions = oldMentionsByVariableName[variableName] || [];
        const newVariableMentions = newMentionsByVariableName[variableName] || [];

        const changeStatusForMentions = findMentionsToResetForVariableNames(
            oldVariableMentions,
            newVariableMentions,
        );

        if (changeStatusForMentions.length > 0) {
            result[variableName] = changeStatusForMentions;
        }
    });

    // Get metions which are added newly and to be removed
    Object.keys(newMentionsByVariableName).forEach((variableName) => {
        const oldVariableMentions = oldMentionsByVariableName[variableName] || [];
        const newVariableMentions = newMentionsByVariableName[variableName] || [];

        const changeStatusForMentions = findMentionsToResetForVariableNames(
            oldVariableMentions,
            newVariableMentions,
        );

        if (changeStatusForMentions.length > 0) {
            result[variableName] = changeStatusForMentions;
        }
    });

    return result;
}

function findMentionsToResetForVariableNames(
    oldVariableMentions: MentionModel[],
    newVariableMentions: MentionModel[],
): MentionModel[] {
    const changeStatusForMentions: MentionModel[] = [];

    newVariableMentions.forEach((newMention) => {
        const found = oldVariableMentions.find((oldMention) =>
            areMentionsEqual(newMention, oldMention),
        );
        if (!found) {
            changeStatusForMentions.push({ ...newMention });
        }
    });

    return changeStatusForMentions;
}

function areMentionsEqual(mention1: MentionModel, mention2: MentionModel): boolean {
    return (
        mention1.index === mention2.index &&
        mention1.matrix === mention2.matrix &&
        mention1.value === mention2.value &&
        mention1.openEnd === mention2.openEnd &&
        mention1.customChoiceIndex === mention2.customChoiceIndex
    );
}

export function updateStatusForHybridQuestionMapppedVariableCells(
    question: QuestionModel,
    reducerState: any,
    variableName: string,
    disableColumnsList: any,
    changeReducerStateForVariableCells: [string, boolean][],
    mentions: { [variableName: string]: MentionModel[] },
) {
    if (question.type === QuestionType.HybridGrid) {
        const mappedFieldIdentifier = `${question.id}&${variableName}`;

        const filteredRows = question.rows?.filter(
            (x) =>
                x.variables &&
                x.variables.length > 0 &&
                x.variables.find((vb) => vb.name === variableName),
        );

        if (filteredRows && filteredRows.length > 0) {
            // Get columns to be disabled for entire row if there is any mention selected for it.
            getDisabledColumnsForVariableBasedOnChoiceSelected(
                filteredRows[0],
                disableColumnsList,
                mentions,
            );

            getNewUpdationStatusForVariables(
                question,
                reducerState,
                filteredRows[0],
                disableColumnsList,
                mappedFieldIdentifier,
                changeReducerStateForVariableCells,
            );
        }
    }
}

export function getDisabledColumnsForVariableBasedOnChoiceSelected(
    row: AxisModel,
    disableColumnsList: any,
    mentions: { [variableName: string]: MentionModel[] },
) {
    row.variables.forEach((loopVariable) => {
        if (loopVariable.choiceList?.length > 0) {
            const mention = mentions[loopVariable.name];

            if (mention && mention.length > 0) {
                loopVariable.choiceList.forEach((choice) => {
                    if (mention && mention.some((x) => x.value === choice.value)) {
                        disableColumnsList.push(getSettingString(choice, "DisableColumns"));
                    }
                });
            }
        }
    });
}

export function getNewUpdationStatusForVariables(
    question: QuestionModel,
    reducerState: any,
    row: AxisModel,
    disableColumnsList: any,
    mappedFieldIdentifier: string,
    changeReducerStateForVariableCells: [string, boolean][],
) {
    row.variables.forEach((loopVariable, index) => {
        const refrencedFieldIdentifier = `${question.id}&${loopVariable.name}`;
        let fieldNewStatus = false;

        if (disableColumnsList && disableColumnsList.length > 0) {
            const isDisabled = disableColumnsList
                .join(",")
                .replace(/\s/g, "")
                .split(",")
                .some((c) => c.toString() === index.toString());

            if (isDisabled && mappedFieldIdentifier !== refrencedFieldIdentifier) {
                fieldNewStatus = true;
            }
        }

        //only update fields if status is changed
        if (
            reducerState[refrencedFieldIdentifier] &&
            reducerState[refrencedFieldIdentifier].isDisabled !== fieldNewStatus
        ) {
            changeReducerStateForVariableCells.push([refrencedFieldIdentifier, fieldNewStatus]);
        }
    });
}
